module.exports = __webpack_public_path__ + "img/Pattern05.17155750.png";